const bloodtestsandresults = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Tests & Results",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Page Title",
                      placeholder: "Enter Page Title",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr11: {
                      type: "hr",
                      size: "12",
                    },
                    info_box: {
                      type: "checkbox",
                      label: "Add Information Box",
                      hideLabel: false,
                      placeholder: "Info Box",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Info Title",
                      placeholder: "Enter Info Title",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr0: {
                      type: "hr",
                      size: "12",
                    },
                    text: {
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "categoryTypes",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              addNewSuccessTitle: "Type Added!",
              addNewSuccessMessage: "Type Added Successfully!",
              addNewErrorTitle: "Type Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Type Deleted!",
              deleteSuccessMessage: "Type Deleted Successfully!",
              deleteErrorTitle: "Type Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Type Activated!",
              activeSuccessMessage: "Type Activated Successfully!",
              activeErrorTitle: "Type Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Type Updated!",
              updateSuccessMessage: "Type Updated Successfully!",
              updateErrorTitle: "Type Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Type",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Type",
                    placeholder: "Enter Type",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  nhs_app: true,
                  patient_access: true,
                  systm_online: true,
                  contact_us: true,
                  description: "",
                },
              },
            },
            children: [
              {
                type: "optionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Types",
                  type: "typeList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    layout_1: {
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter Title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      nhs_app: {
                        type: "toggle",
                        label: "NHS App",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                      patient_access: {
                        type: "toggle",
                        label: "Patient Access",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                      systm_online: {
                        type: "toggle",
                        label: "System Online",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "3",
                        style: "",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      contact_us: {
                        type: "toggle",
                        label: "Contact Us",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      contact_us_description: {
                        type: "ckeditor",
                        label: "Description  ",
                        placeholder: "Enter Description",
                        displayOn: "contact_us",
                        displayOnValue: "true",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      phone_number: {
                        type: "text",
                        label: "Phone Number",
                        placeholder: "Phone Number",
                        displayOn: "contact_us",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 15,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                    },
                    layout_2: {
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter Title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      description: {
                        type: "ckeditor",
                        label: "Description",
                        placeholder: "Enter Description",
                        required: true,
                        info: false,
                        character_count: 2000,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      // nhs_app: {
                      //   type: "toggle",
                      //   label: "NHS App",
                      //   placeholder: "",
                      //   required: false,
                      //   info: true,
                      //   character_count: 0,
                      //   disabled: false,
                      //   class: "",
                      //   size: "3",
                      //   style: "",
                      // },
                      // patient_access: {
                      //   type: "toggle",
                      //   label: "Patient Access",
                      //   placeholder: "",
                      //   required: false,
                      //   info: true,
                      //   character_count: 0,
                      //   disabled: false,
                      //   class: "",
                      //   size: "3",
                      //   style: "",
                      // },
                      // systm_online: {
                      //   type: "toggle",
                      //   label: "System Online",
                      //   placeholder: "",
                      //   required: false,
                      //   info: true,
                      //   character_count: 0,
                      //   disabled: false,
                      //   class: "",
                      //   size: "3",
                      //   style: "",
                      // },
                      // hr1: {
                      //   type: "hr",
                      //   size: "12",
                      // },
                      contact_us: {
                        type: "toggle",
                        label: "Contact Us",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      channel: {
                        type: "select",
                        label: "Channel",
                        placeholder: "Select",
                        displayOn: "contact_us",
                        displayOnValue: "true",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        options: ["Online Consultation", "Telephone"],
                      },
                      online_consultation_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        displayOn: "channel",
                        displayOnValue: "Online Consultation",
                        displayOn2: "contact_us",
                        displayOnValue2: "true",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                      phone_number: {
                        type: "text",
                        label: "Phone Number",
                        placeholder: "Phone Number",
                        displayOn: "channel",
                        displayOnValue: "Telephone",
                        displayOn2: "contact_us",
                        displayOnValue2: "true",
                        required: false,
                        info: false,
                        character_count: 15,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                    },
                    // "content": {
                    //     "type": 'subgroup',
                    //     "label": 'Sub-groups',
                    //     "placeholder": 'Enter Subgroup',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "address": {
                    //     "type": 'text',
                    //     "label": 'Address',
                    //     "placeholder": 'Enter Address',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "date": {
                    //     "type": 'date',
                    //     "label": 'Date',
                    //     "placeholder": 'Enter Date',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  address: "",
                  regular_hours: [
                    {
                      id: 1,
                      title: "Monday",
                      status: [
                        { name: "Closed", value: false },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 2,
                      title: "Tuesday",
                      status: [
                        { name: "Closed", value: false },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 3,
                      title: "Wednesday",
                      status: [
                        { name: "Closed", value: false },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 4,
                      title: "Thursday",
                      status: [
                        { name: "Closed", value: false },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 5,
                      title: "Friday",
                      status: [
                        { name: "Closed", value: false },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 6,
                      title: "Saturday",
                      status: [
                        { name: "Closed", value: true },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                    {
                      id: 7,
                      title: "Sunday",
                      status: [
                        { name: "Closed", value: true },
                        { name: "Interim Closure", value: false },
                      ],
                      opening_time: "08:00",
                      closing_time: "18:30",
                      second_opening_time: "00:00",
                      second_closing_time: "00:00",
                    },
                  ],
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    address: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { bloodtestsandresults };
